module.exports = __webpack_public_path__ + "media/images/alice-38289c5f7a5082ac95222fa27404aba8.png";